import React from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import denied from '../../assets/images/no_permission.png';
import i18n from '../../utilities/i18n';

/**
 * STYLED COMPONENTS
 */

const PageWrapper = styled(Box)(() => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: 'calc(100vh - 100px)',
  backgroundColor: '#F8F9FC',
}));

const StyledCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(10, 4),
  textAlign: 'center',
  width: '100%',
  maxWidth: '1200px',
  minHeight: '80vh',
  borderRadius: '12px',
  border: '1px solid #EEF2F6',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  boxShadow: 'none',
}));

const ImageContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  maxWidth: '220px',
  marginBottom: theme.spacing(4),
}));

const StyledImage = styled('img')({
  width: '137.11px',
  height: 'auto',
});

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  fontSize: '20px',
  marginBottom: theme.spacing(1.5),
  color:theme.palette.text.primary
}));

const DescriptionContainer = styled(Box)({
  maxWidth: '500px',
});

const DescriptionText = styled(Typography)(({ theme }) => ({
    fontWeight: 400,
    fontSize: '14px',
    marginBottom: theme.spacing(1.5),
    color:theme.palette.text.primary
}));

const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(3),
  padding: '8px 20px',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 600,
  borderRadius: '8px',
  backgroundColor: theme.palette.action.primary,
  color: '#FFFFFF',
  '&:hover': {
    backgroundColor: theme.palette.action.highlight,
  },
}));

/**
 * COMPONENT
 */
function NoPermission() {
  return (
    <PageWrapper>
      <StyledCard>
        {/* Illustration */}
        <ImageContainer>
          <StyledImage src={denied} alt="Access Denied" />
        </ImageContainer>

        {/* Heading */}
        <Title variant="h5" component="h1">
        {i18n.t("no_permission.header")}
        </Title>

        {/* Subtext */}
        <DescriptionContainer>
          <DescriptionText variant="body2">
          {i18n.t("no_permission.sub_title")}
          </DescriptionText>
        </DescriptionContainer>

        {/* Action */}
        <ActionButton
          variant="contained"
          disableElevation
          onClick={() => window.history.back()}
        >
           {i18n.t("buttons.goback")}
        </ActionButton>
      </StyledCard>
    </PageWrapper>
  );
}

export default NoPermission;